import React from 'react';
import { useOutletContext } from 'react-router-dom';

import AnimatedBlobBackground from '../../components/common/backgrounds/AnimatedBlobBackground';

export default function Home() {
  const { onOpenAuth, onOpenStudentAuth } = useOutletContext();

  const sections = [
    { selector: '#hero', imagePosition: 'left' },
    { selector: '#userPath', imagePosition: 'center' },
  ];

  const handleOpenAuth = (e) => {
    e.preventDefault();
    onOpenAuth(0);
  };

  const handleStudentOpenAuth = (e) => {
    e.preventDefault();
    onOpenStudentAuth('login');
  };

  return (
    <div>
      {/* Animated Blob Background */}
      <AnimatedBlobBackground sections={sections} />

      {/* Banner section start */}
      <section className="mt-3" id="hero">
        <div className="container mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2">
            <div className="col-span-1">
              <div className="sm:text-left text-center">
                <span className="subheading">evening school</span>
                <h1 className="mt-2">Shape Minds, Build Futures</h1>
                <p className="mt-5">
                  At our Evening School, we believe every student is unique and talented. Each
                  learner has their own strengths, interests, and challenges — and we celebrate that
                  individuality. That’s why we offer personalized education tailored to each
                  student’s current level, passions, and areas for improvement. <br />
                  <br />
                  Our doors are open to students of all ages. Whether you’re beginning something new
                  or continuing your education, you can learn anything you wish and experience the
                  joy of lifelong learning.
                  <br />
                  <br />
                  Our teachers act like doctors of education — they identify your abilities,
                  understand your goals, and guide you step by step on the path to success. Here,
                  you’re not just a student; you’re an individual with unlimited potential, and
                  we’re here to help you reach it.
                  <br />
                  <br />
                </p>
              </div>
            </div>
            <div className="col-span-1 sm:order-last order-first">
              <div className="sm:mb-0 mb-6">
                <img src="/assets/images/home/home-banner.jpeg" alt="Home Banner" />
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Banner section end */}

      {/* Path section start */}
      <section className="mt-20" id="userPath">
        <div className="container w-[80%] mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-20 sm:gap-10">
            <div className="col-span-1">
              <a href="/" onClick={handleStudentOpenAuth}>
                <div className="glass-card card-rounded-icons">
                  <div className="card-icon">
                    <img src="/assets/images/icons/graduated.png" alt="Card Icon" />
                  </div>
                  <h2 className="text-2xl uppercase mt-10">Continue as Parent or Student</h2>
                  <hr className="w-1/3 border-white/20 mt-3 mx-auto" />
                  <p className="mt-5">
                    Join dedicated teachers who will guide you step by step toward academic success
                    and confidence.
                  </p>
                </div>
              </a>
            </div>
            <div className="col-span-1">
              <a href="/" onClick={handleOpenAuth}>
                <div className="glass-card card-rounded-icons">
                  <div className="card-icon">
                    <img src="/assets/images/icons/teacher.png" alt="Card Icon" />
                  </div>
                  <h2 className="text-2xl uppercase mt-10">Continue as Teacher</h2>
                  <hr className="w-1/3 border-white/20 mt-3 mx-auto" />
                  <p className="mt-5">
                    Share your knowledge, conduct online or onsite classes, and help students reach
                    their full potential.
                  </p>
                </div>
              </a>
            </div>
          </div>
        </div>
      </section>
      {/* Path section end */}
    </div>
  );
}
